module.exports = __webpack_public_path__ + "static/img/7.ff712a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/huoban/7.png
// module id = uxSJ
// module chunks = 1